import React from "react";
import MuiTablePagination from "@mui/material/TablePagination";
import PropTypes from "prop-types";

/**
 * TablePagination component wrapper for table pagination.
 * Wraps Material-UI TablePagination with theme integration.
 * 
 * @component
 * @example
 * <TablePagination
 *   count={100}
 *   page={0}
 *   onPageChange={handleChangePage}
 *   rowsPerPage={10}
 *   onRowsPerPageChange={handleChangeRowsPerPage}
 * />
 */
const TablePagination = (props) => {
  return <MuiTablePagination {...props} />;
};

TablePagination.propTypes = {
  /**
   * The component used for displaying the actions
   */
  ActionsComponent: PropTypes.elementType,
  /**
   * Props applied to the rows per page Select element
   */
  SelectProps: PropTypes.object,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * The total number of rows
   */
  count: PropTypes.number.isRequired,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page
   */
  getItemAriaLabel: PropTypes.func,
  /**
   * Customize the displayed rows label
   */
  labelDisplayedRows: PropTypes.func,
  /**
   * Customize the rows per page label
   */
  labelRowsPerPage: PropTypes.node,
  /**
   * Callback fired when the page is changed
   */
  onPageChange: PropTypes.func.isRequired,
  /**
   * Callback fired when the number of rows per page is changed
   */
  onRowsPerPageChange: PropTypes.func,
  /**
   * The zero-based index of the current page
   */
  page: PropTypes.number.isRequired,
  /**
   * The number of rows per page
   */
  rowsPerPage: PropTypes.number.isRequired,
  /**
   * Customizes the options of the rows per page select field
   */
  rowsPerPageOptions: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
      }),
    ])
  ),
  /**
   * If true, show the first-page button
   */
  showFirstButton: PropTypes.bool,
  /**
   * If true, show the last-page button
   */
  showLastButton: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI TablePagination behavior

export default TablePagination;

